"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OldOrderDetail = void 0;
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var lodash_1 = require("lodash");
var discount_types_1 = require("../../types/discount.types");
var order_detail_types_1 = require("../../types/order-detail.types");
var big_numbers_1 = require("../../utils/big-numbers");
var tax_computer_1 = require("../../utils/tax-computer");
var discount_absolute_1 = require("../discount/discount.absolute");
var discount_rate_1 = require("../discount/discount.rate");
var discount_force_total_amount_1 = require("../discount/discount-force-total-amount");
var discount_scope_1 = require("../discount/discount-scope");
var grant_helper_1 = require("../discount/grant-helper");
var fee_1 = require("../fee/fee");
var product_1 = require("../product/product");
var turnover_1 = require("../turnover/turnover");
var OldOrderDetail = /** @class */ (function () {
    function OldOrderDetail(currency, orderDetailProducts, orderDetailFees, orderDetailDiscounts, urssafCompensatoryProduct, usedGrantsShouldBeEffective, isDepositIncludedInTurnover) {
        if (orderDetailProducts === void 0) { orderDetailProducts = []; }
        if (orderDetailFees === void 0) { orderDetailFees = []; }
        if (orderDetailDiscounts === void 0) { orderDetailDiscounts = []; }
        if (usedGrantsShouldBeEffective === void 0) { usedGrantsShouldBeEffective = false; }
        if (isDepositIncludedInTurnover === void 0) { isDepositIncludedInTurnover = false; }
        this.currency = currency;
        this.orderDetailProducts = orderDetailProducts;
        this.orderDetailFees = orderDetailFees;
        this.orderDetailDiscounts = orderDetailDiscounts;
        this.urssafCompensatoryProduct = urssafCompensatoryProduct;
        this.isDepositIncludedInTurnover = isDepositIncludedInTurnover;
        this.products = [];
        this.fees = [];
        this.discounts = [];
        this.next(usedGrantsShouldBeEffective);
    }
    Object.defineProperty(OldOrderDetail.prototype, "recap", {
        get: function () {
            var feeRecap = this.fees.map(function (fee) { return fee.recap; });
            var entranceFeeAmount = this.buildTotalAdmissionAmountFromFeeRecap(feeRecap);
            var discountRecap = this.discounts
                .filter(function (discount) { return OldOrderDetail.discountDisplayFilter(discount); })
                .map(function (discount) { return discount.recap; });
            var grantAmount = (0, grant_helper_1.computeGrantAmount)(discountRecap);
            var totalPrice = this.priceBreakdown;
            var offTurnoverPrice = this.priceBreakdownSpecific((0, turnover_1.selectOffTurnoverProductsAndFees)(this.products, this.fees, this.isDepositIncludedInTurnover));
            var offTurnover = offTurnoverPrice.totalInclTax;
            var turnover = (0, turnover_1.computeTurnoverFromTotalPrice)(totalPrice.totalInclTaxWithDiscount, offTurnover, grantAmount);
            var turnoverWithTaxExcluded = totalPrice.totalExclTaxWithRemise - offTurnoverPrice.totalExclTaxWithRemise;
            return {
                currency: this.currency,
                products: this.products.map(function (product) { return product.recap; }),
                fees: feeRecap,
                discounts: discountRecap,
                taxRatesBreakdown: this.taxRatesBreakdown,
                totalPrice: totalPrice,
                totalLuncheonEligibleAmount: entranceFeeAmount + (0, lodash_1.sum)(this.products.map(function (product) { return product.luncheonEligibleTotalAmount; })),
                globalDiscount: this.globalDiscount,
                urssafCompensatoryProduct: this.urssafCompensatoryProduct,
                entranceFeeAmount: entranceFeeAmount,
                grantAmount: grantAmount,
                turnover: turnover,
                turnoverWithTaxExcluded: turnoverWithTaxExcluded,
                turnoverTotalTax: turnover - turnoverWithTaxExcluded,
                offTurnover: offTurnover,
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OldOrderDetail.prototype, "orderRecap", {
        get: function () {
            return this.recap;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OldOrderDetail.prototype, "globalDiscount", {
        get: function () {
            var _a = this.discounts
                .filter(function (discount) { return discount instanceof discount_rate_1.DiscountByRate && discount.type !== discount_types_1.DISCOUNT_TYPE.GRANT; })
                .reduce(function (_globalDiscount, discount) {
                _globalDiscount.discountedRate = _globalDiscount.discountedRate.multipliedBy(big_numbers_1.big1.minus(discount.rate.dividedBy(big_numbers_1.big10000)));
                if (discount.data.strategy.type === discount_types_1.DISCOUNT_TYPE.PROMOCODE) {
                    _globalDiscount.promocode = {
                        code: discount.data.label,
                        value: discount.data.strategy.value,
                    };
                }
                return _globalDiscount;
            }, { discountedRate: big_numbers_1.big10000, promocode: null }), discountedRate = _a.discountedRate, globalDiscount = __rest(_a, ["discountedRate"]);
            return __assign({ discountRate: big_numbers_1.big10000.minus(discountedRate).integerValue().toNumber() }, globalDiscount);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OldOrderDetail.prototype, "taxRatesBreakdown", {
        get: function () {
            return this.taxRatesBreakdownSpecific(__spreadArray(__spreadArray([], this.products, true), this.fees, true));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OldOrderDetail.prototype, "priceBreakdown", {
        get: function () {
            return this.priceBreakdownSpecific(__spreadArray(__spreadArray([], this.products, true), this.fees, true));
        },
        enumerable: false,
        configurable: true
    });
    OldOrderDetail.prototype.taxRatesBreakdownSpecific = function (productsAndFees) {
        return Array.from(productsAndFees
            .reduce(function (taxesSum, discountable) {
            if (taxesSum.has(discountable.taxRate)) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                var taxSum = taxesSum.get(discountable.taxRate);
                taxesSum.set(discountable.taxRate, {
                    taxRate: discountable.taxRate,
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
                    amount: taxSum.amount.plus(discountable.amount),
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
                    discountedAmount: taxSum.discountedAmount.plus(discountable.discountedAmount),
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
                    remisedAmount: taxSum.remisedAmount.plus(discountable.remisedAmount),
                });
            }
            else {
                taxesSum.set(discountable.taxRate, {
                    taxRate: discountable.taxRate,
                    amount: discountable.amount,
                    discountedAmount: discountable.discountedAmount,
                    remisedAmount: discountable.remisedAmount,
                });
            }
            return taxesSum;
        }, new Map())
            .values()).map(function (_a) {
            var taxRate = _a.taxRate, amount = _a.amount, discountedAmount = _a.discountedAmount, remisedAmount = _a.remisedAmount;
            var _b = (0, tax_computer_1.getPriceBreakdown)(amount, taxRate), totalInclTax = _b[0], totalExclTax = _b[1], totalTax = _b[2];
            var _c = (0, tax_computer_1.getPriceBreakdown)(discountedAmount, taxRate), totalInclTaxWithDiscount = _c[0], totalExclTaxWithDiscount = _c[1], totalTaxWithDiscount = _c[2];
            var _d = (0, tax_computer_1.getPriceBreakdown)(remisedAmount, taxRate), totalInclTaxWithRemise = _d[0], totalExclTaxWithRemise = _d[1], totalTaxWithRemise = _d[2];
            return {
                taxRate: taxRate,
                totalPrice: {
                    totalInclTax: totalInclTax,
                    totalExclTax: totalExclTax,
                    totalTax: totalTax,
                    totalInclTaxWithDiscount: totalInclTaxWithDiscount,
                    totalExclTaxWithDiscount: totalExclTaxWithDiscount,
                    totalTaxWithDiscount: totalTaxWithDiscount,
                    totalInclTaxWithRemise: totalInclTaxWithRemise,
                    totalExclTaxWithRemise: totalExclTaxWithRemise,
                    totalTaxWithRemise: totalTaxWithRemise,
                },
            };
        });
    };
    OldOrderDetail.prototype.priceBreakdownSpecific = function (productsAndFees) {
        return this.taxRatesBreakdownSpecific(productsAndFees).reduce(function (_priceBreakDown, _a) {
            var totalPrice = _a.totalPrice;
            return ({
                totalInclTax: _priceBreakDown.totalInclTax + totalPrice.totalInclTax,
                totalExclTax: _priceBreakDown.totalExclTax + totalPrice.totalExclTax,
                totalTax: _priceBreakDown.totalTax + totalPrice.totalTax,
                totalInclTaxWithDiscount: _priceBreakDown.totalInclTaxWithDiscount + totalPrice.totalInclTaxWithDiscount,
                totalExclTaxWithDiscount: _priceBreakDown.totalExclTaxWithDiscount + totalPrice.totalExclTaxWithDiscount,
                totalTaxWithDiscount: _priceBreakDown.totalTaxWithDiscount + totalPrice.totalTaxWithDiscount,
                totalInclTaxWithRemise: _priceBreakDown.totalInclTaxWithRemise + totalPrice.totalInclTaxWithRemise,
                totalExclTaxWithRemise: _priceBreakDown.totalExclTaxWithRemise + totalPrice.totalExclTaxWithRemise,
                totalTaxWithRemise: _priceBreakDown.totalTaxWithRemise + totalPrice.totalTaxWithRemise,
            });
        }, {
            totalInclTax: 0,
            totalExclTax: 0,
            totalTax: 0,
            totalInclTaxWithDiscount: 0,
            totalExclTaxWithDiscount: 0,
            totalTaxWithDiscount: 0,
            totalInclTaxWithRemise: 0,
            totalExclTaxWithRemise: 0,
            totalTaxWithRemise: 0,
        });
    };
    OldOrderDetail.prototype.buildTotalAdmissionAmountFromFeeRecap = function (fees) {
        return fees.reduce(function (totalAdmissionAmount, fee) {
            return fee.type === order_detail_types_1.FEE_TYPE.ENTRANCE || fee.type === order_detail_types_1.FEE_TYPE.ADMISSION_FEE
                ? totalAdmissionAmount + fee.value
                : totalAdmissionAmount;
        }, 0);
    };
    OldOrderDetail.prototype.buildTotalRoyaltyAmountFromFeeRecap = function (fees) {
        return fees.reduce(function (totalRoyaltyAmount, fee) {
            return fee.type === order_detail_types_1.FEE_TYPE.ROYALTY_FEE ? totalRoyaltyAmount + fee.value : totalRoyaltyAmount;
        }, 0);
    };
    OldOrderDetail.prototype.next = function (usedGrantsShouldBeEffective) {
        if (usedGrantsShouldBeEffective === void 0) { usedGrantsShouldBeEffective = false; }
        this.products = this.generateProducts(__spreadArray([], this.orderDetailProducts, true));
        this.fees = this.generateFees(__spreadArray([], this.orderDetailFees, true));
        this.discounts = this.generateDiscounts(__spreadArray([], this.orderDetailDiscounts, true), __spreadArray(__spreadArray([], this.products, true), this.fees, true), undefined, usedGrantsShouldBeEffective);
    };
    OldOrderDetail.prototype.generateProducts = function (orderDetailProducts) {
        var products = orderDetailProducts
            .filter(function (_a) {
            var quantity = _a.quantity;
            return !!quantity;
        })
            .map(function (orderDetailProduct, index) {
            orderDetailProduct.uniqueDiscountableId = "product-".concat(index, "-").concat(orderDetailProduct.id);
            return new product_1.Product(orderDetailProduct);
        });
        return this.addParentTagsToChildProducts(products);
    };
    OldOrderDetail.prototype.addParentTagsToChildProducts = function (products) {
        var productsWithParentsTag = [];
        for (var i = 0; i < products.length; i++) {
            if (products[i].tags.length > 0) {
                var currentDepth = products[i].depth;
                var parentTags = products[i].tags;
                for (var j = i + 1; j < products.length; j++) {
                    if (products[j].depth <= currentDepth) {
                        break;
                    }
                    products[j].parentTags = products[j].parentTags.concat(parentTags);
                }
            }
            productsWithParentsTag.push(products[i]);
        }
        return productsWithParentsTag;
    };
    OldOrderDetail.prototype.generateFees = function (orderDetailFees) {
        return this.filterNullAdmissionsFromOrderDetailFee(orderDetailFees).map(function (orderDetailFee, index) {
            orderDetailFee.uniqueDiscountableId = "fee-".concat(index);
            return new fee_1.Fee(orderDetailFee);
        });
    };
    OldOrderDetail.prototype.filterNullAdmissionsFromOrderDetailFee = function (fees) {
        var authorizedNullFees = [order_detail_types_1.FEE_TYPE.ENTRANCE, order_detail_types_1.FEE_TYPE.ADMISSION_FEE, order_detail_types_1.FEE_TYPE.ROYALTY_FEE];
        return fees.filter(function (fee) {
            return authorizedNullFees.includes(fee.type) ? fee.value === 0 || fee.value : !!fee.value;
        });
    };
    OldOrderDetail.prototype.generateDiscounts = function (orderDetailDiscounts, discountables, applyGrants, usedGrantsShouldBeEffective) {
        if (applyGrants === void 0) { applyGrants = true; }
        if (usedGrantsShouldBeEffective === void 0) { usedGrantsShouldBeEffective = false; }
        var classedDiscounts = (0, lodash_1.groupBy)(orderDetailDiscounts.filter(function (orderDetailDiscount) { return applyGrants || orderDetailDiscount.strategy.type !== discount_types_1.DISCOUNT_TYPE.GRANT; }), function (discount) { return discount.strategy.applyMethod; });
        var absoluteCartOrderDetailDiscounts = classedDiscounts[discount_types_1.DiscountApplyMethod.ABSOLUTE_CART] || [];
        var grantAbsoluteGlobalOrderDetailDiscounts = classedDiscounts[discount_types_1.DiscountApplyMethod.GRANT_ABSOLUTE_GLOBAL] || [];
        var rateOrderDetailDiscounts = classedDiscounts[discount_types_1.DiscountApplyMethod.RATE] || [];
        var absoluteGlobalOrderDetailDiscounts = classedDiscounts[discount_types_1.DiscountApplyMethod.ABSOLUTE_GLOBAL] || [];
        var totalAmountForceOrderDetailDiscounts = classedDiscounts[discount_types_1.DiscountApplyMethod.FORCE_TOTAL_AMOUNT] || [];
        function getAbsoluteDiscounts(discount, discountApplyMethod) {
            return discount.map(function (orderDetailDiscount) {
                var strategy = orderDetailDiscount.strategy;
                // eslint-disable-next-line prefer-const
                var value = strategy.value, scope = strategy.scope;
                scope = scope || discount_scope_1.defaultDiscountScope[discountApplyMethod];
                return new discount_absolute_1.DiscountByAbsolute(new bignumber_js_1.default(value), __assign(__assign({}, orderDetailDiscount), { strategy: __assign(__assign({}, strategy), { scope: scope }) }), discountables, usedGrantsShouldBeEffective);
            });
        }
        var absoluteCartDiscounts = getAbsoluteDiscounts(absoluteCartOrderDetailDiscounts, discount_types_1.DiscountApplyMethod.ABSOLUTE_CART);
        var grantAbsoluteGlobalDiscounts = getAbsoluteDiscounts(grantAbsoluteGlobalOrderDetailDiscounts, discount_types_1.DiscountApplyMethod.GRANT_ABSOLUTE_GLOBAL);
        // The rate discounts must be grouped by scope to apply a compensation to each scope
        var rateOrderDetailDiscountsByScope = [];
        rateOrderDetailDiscounts.forEach(function (discount) {
            var discountScope = discount.strategy.scope;
            discountScope = discountScope || discount_scope_1.defaultDiscountScope[discount_types_1.DiscountApplyMethod.RATE];
            var rateDiscountByScopeWithSameScope = rateOrderDetailDiscountsByScope.find(function (_a) {
                var scope = _a.scope;
                return new discount_scope_1.DiscountScope(scope).isEqualTo(discountScope);
            });
            if (rateDiscountByScopeWithSameScope) {
                rateDiscountByScopeWithSameScope.discounts.push(discount);
            }
            else {
                rateOrderDetailDiscountsByScope.push({ scope: discountScope, discounts: [discount] });
            }
        });
        var rateDiscounts = [];
        // The compensation discount correct the rounding errors that might occur by applying the discount rate one by one
        // This compensation is done for each scope
        rateOrderDetailDiscountsByScope.forEach(function (_a) {
            var discounts = _a.discounts, scope = _a.scope;
            var toCompensateDiscounts = [];
            discounts.forEach(function (orderDetailDiscount) {
                var strategy = orderDetailDiscount.strategy;
                var value = strategy.value;
                var discount = new discount_rate_1.DiscountByRate(new bignumber_js_1.default(value), __assign(__assign({}, orderDetailDiscount), { strategy: __assign(__assign({}, strategy), { scope: scope }) }), discountables);
                rateDiscounts.push(discount);
                toCompensateDiscounts.push(discount);
            });
            // The totalRate is the equivalent rate of applying the rate discounts one by one
            // Ex: applying a 20% discount and then a 30% discount is equivalent to applying an unique discount with a totalRate of 44%
            var totalRate = big_numbers_1.big10000.minus(toCompensateDiscounts.reduce(function (_discountRate, _a) {
                var rate = _a.rate;
                _discountRate = _discountRate.multipliedBy(big_numbers_1.big1.minus(rate.dividedBy(big_numbers_1.big10000)));
                return _discountRate;
            }, big_numbers_1.big10000));
            var compensationDiscount = new discount_rate_1.DiscountByRateCompensation(totalRate, {
                label: 'COMPENSATION',
                id: 'COMPENSATION',
                strategy: {
                    type: discount_types_1.DISCOUNT_TYPE.COMPENSATION,
                    applyMethod: discount_types_1.DiscountApplyMethod.RATE,
                    scope: scope,
                    value: totalRate.toNumber(),
                },
            }, discountables, toCompensateDiscounts);
            rateDiscounts.push(compensationDiscount);
        });
        var absoluteGlobalDiscounts = getAbsoluteDiscounts(absoluteGlobalOrderDetailDiscounts, discount_types_1.DiscountApplyMethod.ABSOLUTE_GLOBAL);
        // The discounts are applied one by one according to their insertion order
        // The effectiveness only concerns the grants, it's always true for the other discounts
        // If at some point a grant can not be applied (discount.effective is false),
        // the computation is retried without the grants
        var allDiscounts = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], absoluteCartDiscounts, true), grantAbsoluteGlobalDiscounts, true), rateDiscounts, true), absoluteGlobalDiscounts, true), totalAmountForceOrderDetailDiscounts.map(function (totalAmountForceOrderDetailDiscount) {
            return new discount_force_total_amount_1.DiscountForceTotalAmount(totalAmountForceOrderDetailDiscount, discountables);
        }), true);
        // eslint-disable-next-line no-restricted-syntax
        for (var _i = 0, allDiscounts_1 = allDiscounts; _i < allDiscounts_1.length; _i++) {
            var discount = allDiscounts_1[_i];
            if (discount.effective) {
                discount.discount();
            }
        }
        return allDiscounts.filter(function (discount) { return discount.appliedAmount.toNumber() > 0; });
    };
    OldOrderDetail.discountDisplayFilter = function (discount) {
        if (discount instanceof discount_rate_1.DiscountByRateCompensation) {
            return false;
        }
        return !(discount instanceof discount_force_total_amount_1.DiscountForceTotalAmount && discount.recap.amount === 0);
    };
    return OldOrderDetail;
}());
exports.OldOrderDetail = OldOrderDetail;
